export default function colorFromIndex(index, opt = {}) {
  const { seed = 0, alpha = 1, format = alpha < 1 ? "hsla" : "hsl", precision = 3 } = opt;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const mod = (a, m) => ((a % m) + m) % m;

  if (index >= 0 && index < 128) {
    const p = bitReverse7((index + seed * 17) & 127);

    let hue = (p * 360) / 128;
    const satBands = [92, 78, 64, 88, 70, 96, 60, 84];
    const ligBands = [38, 62, 46, 72, 34, 56, 44, 68];

    let sat = satBands[(index ^ (seed * 3)) & 7];
    let lig = ligBands[((index >> 3) ^ (seed * 5)) & 7];

    const j = hash32(index ^ (seed * 0x9e3779b9));
    const j1 = ((j & 1023) / 1023 - 0.5) * 6; // [-3..+3]
    const j2 = (((j >> 10) & 1023) / 1023 - 0.5) * 6; // [-3..+3]
    hue = mod(hue + j1, 360);
    sat = clamp(sat + j2 * 0.8, 50, 98);
    lig = clamp(lig + j1 * 0.6, 26, 78);

    if (hue >= 25 && hue <= 80) {
      lig = clamp(lig - 8, 22, 78);
      sat = clamp(sat + 4, 50, 98);
    }

    if (hue >= 90 && hue <= 165) {
      const flip = (j >> 20) & 1;
      lig = clamp(flip ? lig + 14 : lig - 14, 22, 78);
      sat = clamp(flip ? sat - 10 : sat + 10, 50, 98);
    }

    if (hue >= 200 && hue <= 260) {
      lig = clamp(lig + 8, 22, 78);
    }

    return formatColor(hue, sat, lig, alpha, format, precision);
  }

  const s = hash32(index ^ (seed * 0x85ebca6b));
  const i = (s % 2147483646) + 1;

  const rot = hash32(seed) / 4294967296;
  const x = mod(halton(i, 2) + rot * 0.73, 1);
  const y = mod(halton(i, 3) + rot * 0.37, 1);
  const z = mod(halton(i, 5) + rot * 0.91, 1);

  let hue = x * 360;
  let sat = 45 + y * 55; // 45..100
  let lig = 24 + z * 56; // 24..80

  // ajustes leves
  if (hue >= 25 && hue <= 80) lig -= 6;
  if (hue >= 200 && hue <= 260) lig += 6;

  sat = clamp(sat, 40, 100);
  lig = clamp(lig, 20, 82);

  return formatColor(hue, sat, lig, alpha, format, precision);

  function bitReverse7(n) {
    // reverte 7 bits (0..127)
    n &= 127;
    let r = 0;
    for (let k = 0; k < 7; k++) {
      r = (r << 1) | (n & 1);
      n >>= 1;
    }
    return r;
  }

  function hash32(n) {
    n |= 0;
    n = Math.imul(n ^ 0x9e3779b9, 0x85ebca6b);
    n = Math.imul(n ^ (n >>> 13), 0xc2b2ae35);
    return (n ^ (n >>> 16)) >>> 0;
  }

  function halton(n, base) {
    let f = 1;
    let r = 0;
    while (n > 0) {
      f /= base;
      r += f * (n % base);
      n = Math.floor(n / base);
    }
    return r; // [0,1)
  }

  function formatColor(hue, sat, lig, a, fmt, prec) {
    const p = Math.max(0, prec | 0);
    const h = mod(hue, 360).toFixed(p);
    const s = sat.toFixed(p);
    const l = lig.toFixed(p);

    if (fmt === "hex") return hslToHex(+h, +s, +l);
    if (fmt === "hsla" || a < 1) {
      return `hsla(${h}, ${s}%, ${l}%, ${clamp(a, 0, 1)})`;
    }
    return `hsl(${h}, ${s}%, ${l}%)`;
  }

  function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;

    let r = 0,
      g = 0,
      b = 0;
    if (h < 60) [r, g, b] = [c, x, 0];
    else if (h < 120) [r, g, b] = [x, c, 0];
    else if (h < 180) [r, g, b] = [0, c, x];
    else if (h < 240) [r, g, b] = [0, x, c];
    else if (h < 300) [r, g, b] = [x, 0, c];
    else [r, g, b] = [c, 0, x];

    const toHex = v =>
      Math.round((v + m) * 255)
        .toString(16)
        .padStart(2, "0");

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }
}
